/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface ExpertQuestSectionExpertService
 */
export interface ExpertQuestSectionExpertService {
    /**
     * 
     * @type {string}
     * @memberof ExpertQuestSectionExpertService
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExpertQuestSectionExpertService
     */
    useCount: string;
    /**
     * 
     * @type {string}
     * @memberof ExpertQuestSectionExpertService
     */
    targetUri: string;
    /**
     * 
     * @type {string}
     * @memberof ExpertQuestSectionExpertService
     */
    imageUrl: string;
}

/**
 * Check if a given object implements the ExpertQuestSectionExpertService interface.
 */
export function instanceOfExpertQuestSectionExpertService(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "useCount" in value;
    isInstance = isInstance && "targetUri" in value;
    isInstance = isInstance && "imageUrl" in value;

    return isInstance;
}

export function ExpertQuestSectionExpertServiceFromJSON(json: any): ExpertQuestSectionExpertService {
    return ExpertQuestSectionExpertServiceFromJSONTyped(json, false);
}

export function ExpertQuestSectionExpertServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpertQuestSectionExpertService {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'useCount': json['use_count'],
        'targetUri': json['target_uri'],
        'imageUrl': json['image_url'],
    };
}

export function ExpertQuestSectionExpertServiceToJSON(value?: ExpertQuestSectionExpertService | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'use_count': value.useCount,
        'target_uri': value.targetUri,
        'image_url': value.imageUrl,
    };
}

